import { render, staticRenderFns } from "./CyclerItem.vue?vue&type=template&id=0ffa56ad&"
import script from "./CyclerItem.vue?vue&type=script&lang=ts&"
export * from "./CyclerItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports